import { render } from "./CalendarCurrentMonth.vue?vue&type=template&id=0b945e7d"
import script from "./CalendarCurrentMonth.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CalendarCurrentMonth.vue?vue&type=script&charset=utf-8&lang=js"

import "./CalendarCurrentMonth.vue?vue&type=style&index=0&id=0b945e7d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__